import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const HowItWorks: React.FC = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({
    threshold: 0.2,
    triggerOnce: true
  });

  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6 }
    }
  };

  const steps = [
    {
      id: 1,
      title: 'Diagnóstico',
      description: 'Análise detalhada das necessidades, objetivos e desafios do projeto.'
    },
    {
      id: 2,
      title: 'Planejamento',
      description: 'Desenvolvimento de estratégias e soluções personalizadas.'
    },
    {
      id: 3,
      title: 'Execução',
      description: 'Implementação cuidadosa com acompanhamento contínuo.'
    },
    {
      id: 4,
      title: 'Avaliação',
      description: 'Análise de resultados e ajustes para garantir a satisfação do cliente.'
    }
  ];

  return (
    <section className="section bg-white py-16">
      <div className="container">
        <div className="text-center mb-16">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-3xl md:text-4xl font-bold text-neutral-dark mb-4"
          >
            Como Funciona
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg text-neutral-dark/70 max-w-2xl mx-auto"
          >
            Um processo estruturado e transparente para garantir resultados excepcionais
          </motion.p>
        </div>

        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={controls}
          className="max-w-4xl mx-auto"
        >
          {steps.map((step, index) => (
            <motion.div 
              key={step.id}
              variants={itemVariants}
              className="flex items-start mb-12 relative"
            >
              <div className="flex-shrink-0 mr-6">
                <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center text-white font-bold text-lg">
                  {step.id}
                </div>
                {index < steps.length - 1 && (
                  <div className="absolute left-6 top-12 w-0.5 h-12 bg-primary/30 transform -translate-x-1/2"></div>
                )}
              </div>
              <div>
                <h3 className="text-xl font-bold mb-2 text-neutral-dark">{step.title}</h3>
                <p className="text-neutral-dark/70">{step.description}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks; 